import { render, staticRenderFns } from "./credit-card.vue?vue&type=template&id=990770fa&scoped=true&"
import script from "./credit-card.vue?vue&type=script&lang=ts&"
export * from "./credit-card.vue?vue&type=script&lang=ts&"
import style0 from "./credit-card.vue?vue&type=style&index=0&id=990770fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990770fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
